import './setCssProperties';
import './tooltips';

import journeyAwareness from './journeyAwareness';
import touch from './touch';
import { onWidthResize } from './_utils';
import actionsHandler from './actionsHandler';
import scrollToQueryHash from './scrollToQueryHash';
import chinaAdjustments from './chinaAdjustments';
import alertBanner from './alertBanner';
import anchorLinks from './anchorLinks';
import attachSiteContext from './siteContext';

export default function () {
	$(() => {
		actionsHandler();
		onWidthResize();
		alertBanner();
		journeyAwareness();
		touch();
		scrollToQueryHash();
		chinaAdjustments();
		anchorLinks();
		attachSiteContext();
	});
}
